import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { debounceTime, distinct, distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'g-autocomplete',
  templateUrl: './g-autocomplete.component.html',
  styleUrls: ['./g-autocomplete.component.scss']
})
export class GAutocompleteComponent implements OnInit {
  @Input() control: FormControl;
  @Input() placeholder: string;
  @Input() inputType: string;
  @Input() propertyId = '_id';
  @Input() propertyLabel = 'title';
  @Input() icon?: string = 'edit';
  @Input() name?: string;
  @Input() label?: string;
  @Input() noFloat?: boolean = true;
  @Input() disabled?: boolean;
  @Input() funcLoadData?: (term: string) => any[];
  @Input() matChipInputFor?: any = null;
  public loadingData = false;
  public data = [];
  @ViewChild('autocompleteInput', { static: true }) private autocompleteInput: ElementRef<HTMLInputElement>;

  constructor() { }

  ngOnInit(): void {
    const $fetchDataOnInputKeyup = fromEvent(this.autocompleteInput.nativeElement, 'keyup').pipe(
      map(event => (event.target as HTMLInputElement).value),
      filter(term => term.length >= 2),
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.loadingData = true),
      switchMap(term => this.funcLoadData(term))
    );

    $fetchDataOnInputKeyup
      .subscribe((data) => {
        this.data = data;
        this.loadingData = false;
      });
  }

  public onClickOption(option) {
    this.control.setValue(option);
  }
}
